import store from "@packages/store";
import jwtDecode from 'jwt-decode';
import Vue from "vue";

const commit = (user) => {
    const token = jwtDecode(user.token);
    const mutation = token.accountType === 'ADMIN' ? 'SET_ADMIN' : 'SET_USER';

    const isAdmin = token.accountType === 'ADMIN';

    sessionStorage.setItem("avatar", user.avatar)   

    const userData = isAdmin ? user : { 
        accountId: token.accountId,
        id: token.userId,
        login: token.sub,
        nome: token.userName,
        permissions: token.permissions,
        tipo: token.accountType,
        isSsoUser: token.isSsoUser || false,
        avatar: user.avatar,
    };

    store.commit(mutation, userData);
};

export default {
    async user() {
        const user = await Vue.api.auth.user();

        commit(user);

        return user;
    },

    async login(credentials) {
        const user = await Vue.api.auth.login(credentials);

        store.commit('SET_LOGIN_AS', false);
        store.commit('SET_ADVERTISING_YT_API_KEY', user.youtubePreviewHash);

        localStorage.setItem('loginAs', false);
        localStorage.setItem('youtube-api-key', user.youtubePreviewHash)

        commit(user);

        return user;
    },

    async list({ pagination, filters }) {
        const users = await Vue.api.users.load({ pagination, filters });

        store.commit('SET_USERS_LIST', users);

        return users;
    },
};
